"use client";

import { useGetSiteContent } from "@/hooks/main-hooks";
import { useLocale } from "next-intl";
import Link from "next/link";

export default function CTA() {
  const locale = useLocale();
  const isAr = locale === "ar";

  const { data: site } = useGetSiteContent();
  const cta = site?.cta;

  const title =
    (isAr ? cta?.titleAr : cta?.titleEn) ||
    (isAr ? "جاهز لبدء مشروعك؟" : "Ready to start your project?");

  const description =
    (isAr ? cta?.descriptionAr : cta?.descriptionEn) ||
    (isAr
      ? "تعاون مع الدولية للألومنيوم لتقديم أنظمة ألومنيوم عالمية المستوى تُحوّل رؤيتك المعمارية إلى واقع."
      : "Partner with Al Dawlia for world-class aluminum systems that bring your architectural vision to life.");

  const buttonLabel =
    (isAr ? cta?.buttonLabelAr : cta?.buttonLabelEn) ||
    (isAr ? "تواصل مع فريقنا" : "Contact Our Team");

  const buttonLink = cta?.buttonLink || "/contact";

  return (
    <section
      dir={isAr ? "rtl" : "ltr"}
      className="relative w-full overflow-hidden bg-transparent"
    >
      <div className="md:container mx-auto px-4 md:px-0 lg:w-[85%] relative rounded-3xl mb-10">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center rounded-3xl z-0"
          style={{
            backgroundImage: "url('/cta.jpg')",
          }}
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-brand-navy/85 rounded-3xl" />

        {/* Content */}
        <div className="relative z-10 px-6 sm:px-10 lg:px-16 py-16 sm:py-20 lg:py-24 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">
            {title}
          </h2>

          <p className="mt-4 max-w-2xl mx-auto text-white/80 text-sm sm:text-base lg:text-lg leading-relaxed">
            {description}
          </p>

          <div className="mt-8">
            <Link href={buttonLink}>
              <button className="bg-brand-red hover:bg-brand-blue transition-colors duration-300 text-white font-bold px-8 py-4 rounded-xl text-sm sm:text-base shadow-lg">
                {buttonLabel}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
